import { render, staticRenderFns } from "./WelfareDetailMain.vue?vue&type=template&id=79facb68&scoped=true&"
import script from "./WelfareDetailMain.vue?vue&type=script&lang=js&"
export * from "./WelfareDetailMain.vue?vue&type=script&lang=js&"
import style0 from "./WelfareDetailMain.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./WelfareDetailMain.vue?vue&type=style&index=1&id=79facb68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79facb68",
  null
  
)

export default component.exports